"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOfferUnderContractSubjectFinanceDto = instanceOfOfferUnderContractSubjectFinanceDto;
exports.OfferUnderContractSubjectFinanceDtoFromJSON = OfferUnderContractSubjectFinanceDtoFromJSON;
exports.OfferUnderContractSubjectFinanceDtoFromJSONTyped = OfferUnderContractSubjectFinanceDtoFromJSONTyped;
exports.OfferUnderContractSubjectFinanceDtoToJSON = OfferUnderContractSubjectFinanceDtoToJSON;
exports.OfferUnderContractSubjectFinanceDtoToJSONTyped = OfferUnderContractSubjectFinanceDtoToJSONTyped;
/**
 * Check if a given object implements the OfferUnderContractSubjectFinanceDto interface.
 */
function instanceOfOfferUnderContractSubjectFinanceDto(value) {
    if (!('bank' in value) || value['bank'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('date' in value) || value['date'] === undefined)
        return false;
    return true;
}
function OfferUnderContractSubjectFinanceDtoFromJSON(json) {
    return OfferUnderContractSubjectFinanceDtoFromJSONTyped(json, false);
}
function OfferUnderContractSubjectFinanceDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'bank': json['bank'],
        'type': json['type'],
        'date': json['date'],
    };
}
function OfferUnderContractSubjectFinanceDtoToJSON(json) {
    return OfferUnderContractSubjectFinanceDtoToJSONTyped(json, false);
}
function OfferUnderContractSubjectFinanceDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'bank': value['bank'],
        'type': value['type'],
        'date': value['date'],
    };
}
